import fastdom from 'fastdom';

/**
 * Renders the pagination UI and updates navigation button states.
 * All DOM mutations are wrapped in fastdom to prevent layout thrashing.
 * @param {Object} params
 * @param {HTMLElement} params.optionList - Container element for page number items.
 * @param {HTMLButtonElement} params.previousButton - Button used to navigate to the previous page.
 * @param {HTMLButtonElement} params.nextButton - Button used to navigate to the next page.
 * @param {string} params.html - HTML string representing the pagination items.
 * @param {number} params.currentPage - Currently active page number.
 * @param {number} params.totalPages - Total number of available pages.
 *
 * @returns {void}
 */
export default function paginationRender({
  optionList,
  previousButton,
  nextButton,
  html,
  currentPage,
  totalPages
}) {
  fastdom.mutate(() => {
    optionList.innerHTML = html;
    previousButton.disabled = currentPage === 1;
    nextButton.disabled = currentPage === totalPages;
  });
}
